var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center gap-1"},[_c('BaseLink',{attrs:{"to":"/login"}},[_vm._v("Log In")]),_c('BaseButton',{attrs:{"ga-event":"get_started_main_menu","to":"/registration/","type":"btn-primary"}},[_vm._v("Get Started for Free")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }